import styled from 'styled-components';

export const SustainabilitySection = styled.section`
  padding: 5rem 0;
  background-color: var(--background-color);
  text-align: center;

  @media (max-width: 768px) {
    padding: 3rem 0;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.2rem;
  color: var(--text-color);
  max-width: 700px;
  margin: 0 auto 3rem;
  opacity: 0.8;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
`;

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const Card = styled.div`
  background-color: var(--card-background);
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 20px rgba(0, 0, 50, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border 0.3s ease;
  border: 1px solid rgba(0, 0, 128, 0.1);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: var(--gradient-blue);
    opacity: 0.8;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0, 0, 80, 0.15);
    border: 1px solid rgba(0, 0, 128, 0.2);
  }
`;

export const CardIcon = styled.div`
  font-size: 2.5rem;
  color: var(--primary-color);
  margin-bottom: 1.5rem;
`;

export const CardTitle = styled.h3`
  font-size: 1.5rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
`;

export const CardContent = styled.p`
  font-size: 1rem;
  color: var(--text-color);
  line-height: 1.6;
`;

export const ProductImage = styled.img`
  width: 100%;
  max-width: 150px;
  height: 150px;
  margin: 0 auto 1.5rem;
  display: block;
  object-fit: contain;
  padding: 10px;
  transition: transform 0.3s ease;
  filter: drop-shadow(0 5px 10px rgba(0, 0, 80, 0.1));
  
  &:hover {
    transform: scale(1.05);
  }
`;